"use client";
import React from "react";
import { FaEnvelope } from "react-icons/fa";
import { FaHeadset, FaVideo, FaQuestionCircle } from "react-icons/fa";
import { FaTruckLoading, FaRupeeSign, FaFileInvoice, FaMapMarkerAlt, } from "react-icons/fa";

const features = [
  {
    icon: <FaTruckLoading size={22} />,
    title: "Fast Pickup & Delivery",
    description: "Pickup within 20 minutes, 30-45 min delivery",
    color: "from-blue-500 to-blue-600",
    bg: "bg-blue-50",
    border: "border-blue-100",
  },
  {
    icon: <FaRupeeSign size={22} />,
    title: "Affordable Logistics",
    description: "Starting from just ₹13/km for intra-city shipping",
    color: "from-emerald-500 to-emerald-600",
    bg: "bg-emerald-50",
    border: "border-emerald-100",
  },
  {
    icon: <FaFileInvoice size={22} />,
    title: "No GST Required",
    description: "Start shipping without GST registration",
    color: "from-violet-500 to-violet-600",
    bg: "bg-violet-50",
    border: "border-violet-100",
  },
  {
    icon: <FaMapMarkerAlt size={22} />,
    title: "Real-Time Tracking",
    description: "Track every shipment live with full support",
    color: "from-amber-500 to-amber-600",
    bg: "bg-amber-50",
    border: "border-amber-100",
  },
];

const contactData = [
  {
    title: "Customer Support",
    subtitle: "Got a query for us? Our support experts are just a click away.",
    num: "01",
    contacts: [
      { label: "Domestic Shipping", email: "sales@sureship.in" },
      { label: "Cross Border Shipping", email: "support@sureship.com" },
      { label: "Warehouse Fulfillment", email: "sales@sureship.in" },
    ],
  },
  {
    title: "Sales",
    subtitle: "Talk to our sales expert to kick start your worldwide shipping journey.",
    num: "02",
    contacts: [
      { label: "Domestic Shipping", email: "sales@sureship.in" },
      { label: "Cross Border Shipping", email: "sales@sureship.in" },
      { label: "Warehouse Fulfillment", email: "sales@sureship.in" },
    ],
  },
];

const contactDataa = [
  {
    icon: <FaHeadset size={22} />,
    title: "Support",
    subtitle: "Reach Us",
    color: "from-blue-500 to-blue-600",
    bg: "bg-blue-50",
    border: "border-blue-100",
  },
  {
    icon: <FaHeadset size={22} />,
    title: "Product Demo",
    subtitle: "Schedule a product demo",
    color: "from-indigo-500 to-indigo-600",
    bg: "bg-indigo-50",
    border: "border-indigo-100",
  },
  {
    icon: <FaVideo size={22} />,
    title: "Media & Communication",
    subtitle: "Media and Press information",
    color: "from-violet-500 to-violet-600",
    bg: "bg-violet-50",
    border: "border-violet-100",
  },
  {
    icon: <FaQuestionCircle size={22} />,
    title: "HR Queries",
    subtitle: "Connect with HR",
    color: "from-teal-500 to-teal-600",
    bg: "bg-teal-50",
    border: "border-teal-100",
  },
];

const locations = [
  { city: "Gurgaon", address: "The Office Pass, 7th Floor, Paras Downtown Center, 54, Golf Course Rd, Near Sector 53, DLF Phase 5, Gurugram, Haryana 122003", highlight: true },
  { city: "Delhi", address: "Ground Flr, 101, A-17/2, Street No-2, Mahipalpur Ex, Delhi-110037", highlight: true },
  { city: "Mumbai", address: "Office No-5 B Vakratund Soc. Shambhaji Nagar, Opp Vijay Nagar, Sahar Road, Andheri East, Mumbai – 400069" },
  { city: "Bangalore", address: "Ist Cross, Office No-5, Vinayaka Nagar, Wilson Garden, Near Wilson Garden Police Station, Bangalore-560030" },
  { city: "Hyderabad", address: "1-16-27/16, Prakash Nagar, Begumpet, Hyderabad - 500016" },
  { city: "Kolkata", address: "171/C/1 Mannat Apartment, Vinay Singh Colony, Picnic Garden, Kolkata 700039" },
  { city: "Chennai", address: "Ground Flr, Amarjohn Street, Choolaimedu High Road (Nungambakkam) - 600094" },
  { city: "Patna", address: "Office No-151, Shanti Niwas J.P Road, Mahendru, Patna, Bihar 800006" },
  { city: "Jammu", address: "House No 41, Sector 11, Nanak Nagar, Shivaji Chowk, Jammu – 180004" },
  { city: "Jalandhar", address: "Off No. 169, Beant Nagar, Near PAP Line, Jalandhar - 144006" },
  { city: "Chandigarh", address: "Plot No 94, City Enclave, Pabhat Road, Zirakpur, Chandigarh - 140603" },
  { city: "Guwahati", address: "By Lane No 3, H. No-09, Girijananda Choudhury Path, Birubari, Shankarpur, Guwahati - 781016" },
  { city: "Jaipur", address: "F7, Subhash Nagar Shopping Center, Jaipur – 302016" },
  { city: "Pune", address: "Survey No-71, Shreenath Nagar, BT Kawade Road, Gopal Steel, Ghorpadi Gaon, Pune - 411001" },
  { city: "Ahmedabad", address: "L6, Ghantakarna Market, Sarangpur, Ahmedabad - 380002" },
  { city: "Surat", address: "1/J, Japan Market, Ring Road, Surat - 395002" },
  { city: "Ranchi", address: "Shop No-83, Sainik Market, Main Road, Ranchi - 834001" },
  { city: "Lucknow", address: "Shyamkung Colony, Khramnagar, Lucknow - 226022" },
];

export default function Page() {
  return (
    <div className="bg-white text-gray-900 font-sans">

      {/* ── HERO — matches dark comparison section from home page ── */}
      <section className="bg-gradient-to-b from-slate-900 to-slate-800 text-white pt-40 pb-24 px-4 md:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] text-blue-300 uppercase bg-blue-500/20 border border-blue-400/30 px-4 py-1.5 rounded-full mb-6">
            Contact Us
          </span>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-6">
            Need Assistance?{" "}
            <span className="text-blue-400">We're Just a Message Away</span>
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
            Whether you have a question, need technical support, or want to explore our
            services, our dedicated team is here to assist you every step of the way.
            Reach out to us anytime — we're happy to help!
          </p>
        </div>
      </section>

      {/* ── CUSTOMER CARE — same grid bg + tinted card as benefits section ── */}
      <section className="relative overflow-hidden pt-20 pb-20 px-4 md:px-16">
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              "linear-gradient(#1e40af 1px, transparent 1px), linear-gradient(to right, #1e40af 1px, transparent 1px)",
            backgroundSize: "60px 60px",
          }}
        />
        <div className="relative max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-blue-600 uppercase bg-blue-50 border border-blue-100 px-4 py-1.5 rounded-full mb-4">
              Customer Care
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5 leading-tight">
              We're Here to{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                Help You
              </span>
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-5">
            {/* Info card — same tinted card style as benefits */}
            <div className="md:col-span-2 group relative overflow-hidden rounded-2xl border border-blue-100 bg-blue-50 p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
              <div className="flex items-start gap-4 mb-6">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white shadow-sm">
                  <FaHeadset size={20} />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1">Dedicated Support Team</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    At Sureship, we are committed to providing exceptional customer support and
                    logistics solutions. Reach us via our Customer Query Form or email us at{" "}
                    <a href="mailto:sales@sureship.in" className="text-blue-600 font-semibold hover:underline">
                      sales@sureship.in
                    </a>
                  </p>
                </div>
              </div>
              <ul className="space-y-3">
                {[
                  "Customer service available in English and Hindi",
                  "Service hours: 09:00 AM – 07:00 PM IST, Monday to Saturday",
                  "Standard call rates may apply",
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm text-gray-600">
                    <span className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white text-xs">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Head Office — matches blue gradient card from comparison section */}
            <div className="relative rounded-2xl bg-gradient-to-br from-blue-600 to-indigo-700 p-7 text-white flex flex-col justify-between shadow-2xl shadow-blue-900/30">
              <div className="absolute top-4 right-4 text-[10px] font-bold tracking-widest uppercase bg-white/20 text-white px-3 py-1 rounded-full">
                Head Office
              </div>
              <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center mb-4">
                <FaMapMarkerAlt size={16} />
              </div>
              <div>
                <p className="text-xs font-semibold tracking-widest uppercase text-blue-200 mb-2">Gurgaon HQ</p>
                <p className="text-sm text-blue-50 leading-relaxed">
                  The Office Pass, 7th Floor, Paras Downtown Center, 54, Golf Course Rd,
                  Near Sec 53, DLF Phase 5, Gurugram, Haryana 122003
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTACT & SALES — same numbered card style as Core Values ── */}
      <section className="py-20 px-4 md:px-16 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="mb-16">
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-blue-600 uppercase bg-blue-50 border border-blue-100 px-4 py-1.5 rounded-full mb-4">
              Get In Touch
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0a0055]">
              Contact & Sales
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {contactData.map((section, idx) => (
              <div
                key={idx}
                className="group relative overflow-hidden rounded-2xl border border-gray-100 bg-gradient-to-br from-white to-blue-50/50 p-8 hover:shadow-lg hover:border-blue-200 transition-all duration-300"
              >
                <span className="absolute top-6 right-6 text-6xl font-black text-blue-50 group-hover:text-blue-100 transition-colors select-none">
                  {section.num}
                </span>
                <div className="w-8 h-1 bg-blue-400 rounded-full mb-5" />
                <h3 className="text-xl font-bold text-blue-900 mb-2">{section.title}</h3>
                <p className="text-gray-500 text-sm mb-6 leading-relaxed">{section.subtitle}</p>
                <div className="space-y-4">
                  {section.contacts.map((item, index) => (
                    <div key={index} className={`${index !== 0 ? "pt-4 border-t border-slate-100" : ""}`}>
                      <p className="font-semibold text-gray-800 text-sm mb-1.5">{item.label}</p>
                      <div className="flex items-center gap-2.5 text-sm text-gray-500">
                        <FaEnvelope className="text-blue-500 flex-shrink-0" size={12} />
                        <a href={`mailto:${item.email.trim()}`} className="hover:text-blue-600 hover:underline transition-colors">
                          {item.email.trim()}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE — same tinted benefit cards ── */}
      <section className="relative overflow-hidden py-20 px-4 md:px-16">
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              "linear-gradient(#1e40af 1px, transparent 1px), linear-gradient(to right, #1e40af 1px, transparent 1px)",
            backgroundSize: "60px 60px",
          }}
        />
        <div className="relative max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-blue-600 uppercase bg-blue-50 border border-blue-100 px-4 py-1.5 rounded-full mb-4">
              Our Edge
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5 leading-tight">
              Why Choose{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                Sureship?
              </span>
            </h2>
            <p className="text-gray-500 max-w-2xl mx-auto text-lg leading-relaxed">
              Sureship provides on-demand logistics within the city, helping D2C brands and
              local businesses ship products faster and more efficiently. Our reliable 30-45
              minute delivery ensures your packages reach customers on time, every time.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`group relative overflow-hidden rounded-2xl border ${feature.border} ${feature.bg} p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300`}
              >
                <div className="flex items-start gap-4">
                  <div className={`flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br ${feature.color} flex items-center justify-center text-white shadow-sm`}>
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── QUICK CONTACT OPTIONS — same tinted caaard style ── */}
      <section className="py-20 px-4 md:px-16 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-blue-600 uppercase bg-blue-50 border border-blue-100 px-4 py-1.5 rounded-full mb-4">
              How Can We Help
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Choose Your{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                Channel
              </span>
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {contactDataa.map((item, index) => (
              <div
                key={index}
                className={`group relative overflow-hidden rounded-2xl border ${item.border} ${item.bg} p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer text-center`}
              >
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white shadow-sm mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  {item.icon}
                </div>
                <h3 className="text-base font-semibold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.subtitle}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── LOCATIONS — matches dark comparison section ── */}
      <section className="bg-gradient-to-b from-slate-900 to-slate-800 text-white py-24 px-4 md:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-blue-300 uppercase bg-blue-500/20 border border-blue-400/30 px-4 py-1.5 rounded-full mb-4">
              Pan India Presence
            </span>
            <h2 className="text-4xl md:text-5xl font-bold leading-tight">
              Key Corporate Locations{" "}
              <span className="text-blue-400">across India</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {locations.map((loc) => (
              <div
                key={loc.city}
                className={`group relative rounded-2xl p-5 border transition-all duration-300 hover:-translate-y-1 ${loc.highlight
                  ? "bg-gradient-to-br from-blue-600 to-indigo-700 border-blue-500 shadow-2xl shadow-blue-900/40"
                  : "bg-white/5 border-white/10 hover:border-white/20 hover:shadow-lg"
                  }`}
              >
                {loc.highlight && (
                  <span className="absolute top-3 right-3 text-[10px] font-bold tracking-widest uppercase bg-white/20 text-white px-2 py-0.5 rounded-full">
                    HQ
                  </span>
                )}
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-3 ${loc.highlight ? "bg-white/20" : "bg-white/10"}`}>
                  <FaMapMarkerAlt size={13} className="text-white" />
                </div>
                <h3 className="font-bold text-base text-white mb-2">{loc.city}</h3>
                <p className={`text-xs leading-relaxed ${loc.highlight ? "text-blue-100" : "text-slate-400"}`}>
                  {loc.address}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}